function Sustain() {
  return (
    <div className="sustain__container">
      <div className="sustain__wrapper row">
        <div className="sustain__content right-border">
          <div className="sustain__content-wrapper column">
            <div className="sustain__content-title"><h1>지속성</h1></div>
            <div className="sustain__content-text">
              <p><b>지속성</b>은 저희 회사의 핵심가치입니다. 마오리 원칙인 카이티아키탕가에 따라, 우리는 현재와 미래의 세대를 위해 육지와 바다, 그리고 우리들을 지키기 위한 노력을 계속하고 있습니다. 말하자면, 저희의 약속은 단순히 환경에 주는 영향을 줄이는 것만이 아니라, 변화를 이끌어 가겠다는 것이기도 합니다. </p>
            </div>
          </div>
        </div>
        <div className="sustain__content">
          <div className="sustain__content-wrapper column">
            <div className="sustain__content-title"><h1>식품 안전</h1></div>
            <div className="sustain__content-text">
              <p><b>식품 안전</b>은 뉴질랜드의 식품 생산자들에게 가장 중요한 것입니다. 따라서, 라이프스팬은 엄격한 식품위생 기준과 관례을 가지고 있습니다. 마찬가지로, 저희는 최고 품질의 제품만을 유통할 수 있도록 첨단 기술과 품질 관리에 심혈을 기울입니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sustain;